import { Skeleton } from '@shared/components/ui/shadcn';

export const EntryDetailsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 gap-8">
      <div className="lg:col-span-2">
        <div className="sticky top-6 space-y-2">
          <Skeleton className="h-6 w-40 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
        </div>
      </div>
      <div className="lg:col-span-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2 md:col-span-2">
            <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-36 rounded-full bg-hover-press" />
            <Skeleton className="h-10 w-full bg-hover-press" />
          </div>
        </div>
      </div>
    </div>
  );
};

